// Full-screen bootstrap splash. Renders while the app is fetching the
// initial server list so the PrimarySidebar rail doesn't flash all
// modules (default-true fallback in isModuleEnabled) and then snap to
// the filtered set once enabledModules arrives. App.tsx returns this
// in place of the routed UI until isAuthenticated && serversLoaded.
//
// Visual: centered Rx2Go logo on the page background with a soft
// gentle pulse — no progress text, no spinner ring (the pulse alone
// conveys "still working"). Falls back to a text "R2" badge if the
// logo asset is missing, mirroring the rail logo's onError handler.

export default function SplashScreen() {
  // Geometry MUST match the HTML #boot-splash in apps/web/index.html:
  // a bare 80×80 pulsing logo, no wrapper padding. Earlier this had
  // a `w-20 h-20` flex container with `p-2` on the img → effective
  // logo was 64×64, while the HTML splash was 80×80 → visible ~20%
  // shrink the moment React took over. Keep the two in sync.
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background">
      <img
        src={`${import.meta.env.BASE_URL}logo-icon.svg`}
        alt="Rx2Go"
        className="w-20 h-20 object-contain animate-pulse"
        onError={(e) => {
          const img = e.target as HTMLImageElement
          const parent = img.parentElement
          if (parent && !parent.querySelector('span.splash-logo-fallback')) {
            img.style.display = 'none'
            const span = document.createElement('span')
            span.className =
              'splash-logo-fallback text-primary-foreground font-bold text-xl bg-primary w-20 h-20 rounded-2xl flex items-center justify-center animate-pulse'
            span.textContent = 'R2'
            parent.appendChild(span)
          }
        }}
      />
    </div>
  )
}
